// there is a bug in pygeno. in UK and Germany locale symbol is at the end.
// we must use us-DE, us-UK to format it at the beginning.
import { User } from './models';

export type Locale = 'en-US' | 'en-DE' | 'en-GB';
export type Currency = 'USD' | 'EUR' | 'GBP';

export function getLocale(user: User): Locale {
  return <Locale>{ de: 'en-DE', uk: 'en-GB', com: 'en-US' }[user.region.toLowerCase()] ?? 'en-US';
}

export function getCurrency(locale: Locale): Currency {
  return <Currency>{ 'en-US': 'USD', 'en-GB': 'GBP', 'en-DE': 'EUR' }[locale];
}

export function formatPrice(price: number, currency: Currency, locale?: Locale): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
  }).format(price);
}

export function formatPriceAccordingToUserLocale(user: User, price: number): string {
  const locale = getLocale(user);

  return formatPrice(price, getCurrency(locale), locale);
}
